import Vue from 'vue';
import Vuex from 'vuex';

import user from './module/user';
import app from './module/app';
import permission from './module/permission';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //
    approval: '',
  },
  getters: {
    //
    approval: (state) => state.approval,
  },
  mutations: {
    //
    setApproval(state, approval) {
      state.approval = approval;
    },
  },
  actions: {
    //
    updateApproval({ commit }, approval) {
      commit('setApproval', approval);
    },
  },
  modules: {
    user,
    app,
    permission,
  },
});
